import { Http } from "@/http";
const isProd = "cbo-merchant-web";
/**
 * 服务生产配置详情
 */
export const messageList = (payload) => {
  return Http.post({
    url: `/${isProd}/message/messageList`,
    data: payload,
  });
};
export const setReadFlag = (payload) => {
  return Http.post({
    url: `/${isProd}/message/setReadFlag`,
    data: payload,
  });
};
export const queryMsgCount = (payload) => {
  return Http.post({
    url: `/${isProd}/message/queryMsgCount`,
    data: payload,
  });
};
//** 查询账号密码接口
export const lookAccount = (payload) => {
  return Http.post({
    url: `/cbo-wb-oauth/provider/findEvidenceByAccount`,
    data: { ...payload },
  });
};
